import React from "react";
import { escapeRegExp } from "lodash";

interface HighlightedTextProps {
  text: string;
  query: string;
  className?: string;
}

const HighlightedText: React.FC<HighlightedTextProps> = ({
  text,
  query,
  className
}) => {
  if (!query.trim()) {
    return <span className={className}>{text}</span>;
  }

  const parts = text.split(new RegExp(`(${escapeRegExp(query)})`, "gi"));

  return (
    <span className={className} data-searchable>
      {parts.map((part, index) => {
        const isMatch = part.toLowerCase() === query.toLowerCase();
        return (
          <span
            key={index}
            className="rounded"
            data-match={isMatch || undefined}
          >
            {part}
          </span>
        );
      })}
    </span>
  );
};

export default HighlightedText;
